/* ============================================
   THE ZUMBLIES — cart.js (Shopify AJAX cart)
   Uses real /cart endpoints, no fake cart state.
   ============================================ */

(function () {
  'use strict';

  const $ = (s, p = document) => p.querySelector(s);
  const $$ = (s, p = document) => Array.from(p.querySelectorAll(s));

  const fmt = (cents) => {
    const v = (cents / 100).toFixed(2);
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'USD')
      ? '$' + v
      : v + ' ' + (window.Shopify?.currency?.active || 'USD');
  };

  // ---------- Cart drawer DOM (created on demand) ----------
  function ensureDrawer() {
    if ($('#zb-cart-drawer')) return;

    const overlay = document.createElement('div');
    overlay.className = 'cart-overlay';
    overlay.id = 'zb-cart-overlay';
    overlay.addEventListener('click', closeCart);

    const drawer = document.createElement('aside');
    drawer.className = 'cart-drawer';
    drawer.id = 'zb-cart-drawer';
    drawer.setAttribute('aria-hidden', 'true');
    drawer.innerHTML = `
      <div class="cart-header">
        <h3>Your cart</h3>
        <button class="cart-close" aria-label="Close cart">×</button>
      </div>
      <div class="cart-items" id="zb-cart-items"></div>
      <div class="cart-footer hidden" id="zb-cart-footer">
        <div class="cart-subtotal">
          <span>Subtotal</span>
          <span id="zb-cart-subtotal">$0</span>
        </div>
        <a href="/checkout" class="btn btn-primary btn-lg cart-checkout">Check out</a>
      </div>
    `;

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    drawer.querySelector('.cart-close').addEventListener('click', closeCart);
  }

  function openCart() {
    ensureDrawer();
    $('#zb-cart-drawer').classList.add('open');
    $('#zb-cart-overlay').classList.add('open');
    $('#zb-cart-drawer').setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCart() {
    const d = $('#zb-cart-drawer');
    if (d) d.classList.remove('open');
    const o = $('#zb-cart-overlay');
    if (o) o.classList.remove('open');
    document.body.style.overflow = '';
  }

  // ---------- Cart fetch / render ----------
  async function fetchCart() {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }

  function renderCart(cart) {
    ensureDrawer();
    const itemsEl = $('#zb-cart-items');
    const footerEl = $('#zb-cart-footer');
    const subEl = $('#zb-cart-subtotal');

    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = `<div class="cart-empty">
        <p style="font-size:16px; margin-bottom: 8px;">Your cart is empty.</p>
        <p style="font-size:14px;">Browse the <a href="/collections/all" style="color:var(--ink); text-decoration: underline;">shop</a>.</p>
      </div>`;
      footerEl.classList.add('hidden');
      updateCount(0);
      return;
    }

    itemsEl.innerHTML = cart.items.map((item) => `
      <div class="cart-item" data-key="${item.key}">
        <img src="${item.image || ''}" alt="${escapeHtml(item.product_title)}">
        <div>
          <div class="ci-title">${escapeHtml(item.product_title)}</div>
          <div class="ci-price">Qty ${item.quantity} · ${fmt(item.final_line_price)}</div>
          <button class="ci-remove" data-remove="${item.key}">Remove</button>
        </div>
        <div style="font-weight:700;">${fmt(item.final_line_price)}</div>
      </div>
    `).join('');

    subEl.textContent = fmt(cart.total_price);
    footerEl.classList.remove('hidden');
    updateCount(cart.item_count);

    // wire remove buttons
    $$('[data-remove]', itemsEl).forEach((btn) => {
      btn.addEventListener('click', async () => {
        const key = btn.getAttribute('data-remove');
        await changeItem(key, 0);
      });
    });
  }

  async function refreshCart() {
    const cart = await fetchCart();
    renderCart(cart);
    return cart;
  }

  function updateCount(n) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
    });
  }

  // ---------- Cart actions ----------
  async function addItem(variantId, quantity = 1) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity }] })
    });
    if (!r.ok) {
      const err = await r.json().catch(() => ({}));
      throw new Error(err.description || 'Could not add to cart');
    }
    return refreshCart();
  }

  async function changeItem(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    return refreshCart();
  }

  // ---------- Wire up event delegation ----------
  document.addEventListener('click', async (e) => {
    // Open cart
    const opener = e.target.closest('[data-cart-open]');
    if (opener) {
      e.preventDefault();
      openCart();
      return;
    }

    // Add to cart (data attribute approach)
    const adder = e.target.closest('[data-add-variant]');
    if (adder) {
      e.preventDefault();
      const variantId = adder.getAttribute('data-add-variant');
      if (!variantId) {
        alert('This product is not yet linked. Add the product in Shopify Admin and connect it in the Theme Editor.');
        return;
      }
      const original = adder.textContent;
      adder.disabled = true;
      adder.textContent = 'Adding…';
      try {
        await addItem(variantId, 1);
        adder.textContent = 'Added ✓';
        openCart();
        setTimeout(() => { adder.textContent = original; adder.disabled = false; }, 1200);
      } catch (err) {
        adder.textContent = 'Error';
        alert(err.message || 'Could not add to cart');
        setTimeout(() => { adder.textContent = original; adder.disabled = false; }, 1500);
      }
    }
  });

  // Forms with action /cart/add (real product forms)
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    const data = {};
    for (const [k, v] of fd.entries()) data[k] = v;
    const id = data.id;
    const quantity = parseInt(data.quantity || '1', 10);
    if (!id) return;

    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
      var originalLabel = submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding…';
    }
    try {
      await addItem(id, quantity);
      if (submitBtn) submitBtn.textContent = 'Added ✓';
      openCart();
      setTimeout(() => {
        if (submitBtn) { submitBtn.textContent = originalLabel; submitBtn.disabled = false; }
      }, 1200);
    } catch (err) {
      if (submitBtn) submitBtn.textContent = 'Error';
      alert(err.message || 'Could not add to cart');
      setTimeout(() => {
        if (submitBtn) { submitBtn.textContent = originalLabel; submitBtn.disabled = false; }
      }, 1500);
    }
  });

  // Mobile menu toggle
  document.addEventListener('click', (e) => {
    if (e.target.closest('.menu-btn')) {
      const links = document.querySelector('header.site .links');
      if (links) links.classList.toggle('open');
    }
  });

  // Init: load count on page load
  document.addEventListener('DOMContentLoaded', async () => {
    try {
      const cart = await fetchCart();
      updateCount(cart.item_count);
    } catch (e) { /* offline / preview, no-op */ }
  });

  // Expose for inline onclick fallback
  window.ZB = { openCart, closeCart, addItem, refreshCart };

  function escapeHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
})();
